export default "__VITE_ASSET__6bSfU$Pn__"